<template>
  <b-modal size="xl" :id="modalId" hide-footer hide-header>
    <div>
      <button class="closeModal" @click="$bvModal.hide(modalId)">
        <b-icon-x scale="1.3" />
      </button>

      <PaymentMethods @listPaymentMethods="listPaymentMethods" />
    </div>
  </b-modal>
</template>

<script>
import PaymentMethods from "../PaymentMethods/index.vue";
export default {
  props: {
    modalId: {
      type: String,
      default: "modalPaymentMethods",
    },
  },
  data() {
    return {};
  },
  components: {
    PaymentMethods,
  },
  methods: {
    listPaymentMethods() {
      this.$emit("listPaymentMethods");
    },
  },
  watch: {},
  computed: {},
};
</script>

<style scoped>
.btnBack {
  border-radius: 5px;
  background-color: #006256;
  border: none;
  margin-top: 30px;
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 13px;
  width: 150px;
  font-size: 18px;
  margin-top: 0;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}
</style>